/* eslint-disable camelcase */

import { AxiosRequestConfig } from "axios";
import { ArchiveDeleteResponse } from "components/common/ArchiveDialog/ArchiveDialog";
import { SWRConfiguration } from "swr";
import { ApiResponse, ServerResponse } from "./axiosConfig";
import { axiosInst, useSwr } from "./axiosHVS";
import { HvsEntity } from "./hvsBase";

export const getEntity = (
  id: string | undefined,
  typeId: string | undefined,
  includeTriggerResult: boolean,
  config?: AxiosRequestConfig
): Promise<HvsEntity | undefined> => {
  if (id === undefined || id === "" || typeId === undefined || typeId === "") {
    return new Promise<HvsEntity | undefined>((resolve) => {
      resolve(undefined);
    });
  }

  const baseCameraKey = `entitytypes/${typeId}/entities/${id}`;
  return axiosInst
    .get<ApiResponse<HvsEntity>>(
      `${baseCameraKey}?includeTriggerResult=${includeTriggerResult}`,
      config
    )
    .then((v) => {
      return v.data.data;
    });
};
export const useEntity = (
  id: string | undefined,
  typeId: string | undefined,
  includeTriggerResult: boolean,
  config?: SWRConfiguration
): ServerResponse<ApiResponse<HvsEntity | undefined>> => {
  const baseCameraKey = `entitytypes/${typeId}/entities/${id}`;
  return useSwr<ApiResponse<HvsEntity | undefined>>(
    typeId && id
      ? `${baseCameraKey}?includeTriggerResult=${includeTriggerResult}`
      : null,
    config
  );
};

export const deleteEntities = async (
  typeId: string,
  entityIds: string[]
): Promise<ArchiveDeleteResponse<string>> => {
  const baseCameraKey = `bulk/entitytypes/${typeId}/entities/delete/`;
  const res = await axiosInst.post(`${baseCameraKey}`, entityIds);
  return res.data;
};
